<div class="treelist-pager">
  <!-- First / Prev -->
  <span class="k-link k-pager-nav" [class.k-state-disabled]="currentPage === 1" (click)="goToFirst()" title="First page">
    <span class="k-icon k-i-seek-w"></span>
  </span>
  <span class="k-link k-pager-nav" [class.k-state-disabled]="currentPage === 1" (click)="goToPrev()" title="Previous page">
    <span class="k-icon k-i-arrow-w"></span>
  </span>

  <!-- Page number buttons with ellipsis -->
  <ng-container *ngFor="let p of getPageNumbers()">
    <span *ngIf="p === 'ellipsis'" class="k-link k-pager-nav">...</span>
    <span class="k-link k-pager-nav"
      *ngIf="p !== 'ellipsis'"
      [class.k-state-selected]="p === currentPage"
      (click)="goToPage(+p)"
    >{{p}}</span>
  </ng-container>

  <!-- Next / Last -->
  <span class="k-link k-pager-nav" [class.k-state-disabled]="currentPage === totalPages" (click)="goToNext()" title="Next page">
    <span class="k-icon k-i-arrow-e"></span>
  </span>
  <span class="k-link k-pager-nav" [class.k-state-disabled]="currentPage === totalPages" (click)="goToLast()" title="Last page">
    <span class="k-icon k-i-seek-e"></span>
  </span>

  <!-- Page size selector (before info, matching Kendo layout) -->
  <span class="pager-sizes align-items-center">
    <kendo-dropdownlist 
        [data]="pageSizes" 
        [value]="pageSize" 
        (valueChange)="onPageSizeChange($event)" 
        style="width: 78px;">
    </kendo-dropdownlist>
    <span class="k-label mb-0">items per page</span>
  </span>

  <!-- Info text — pushed to far right -->
  <span class="k-pager-info k-label">
    {{ rangeStart }} - {{ rangeEnd }} of {{ total | number }} items
  </span>
</div>
